import mutations from './mutations'
import actions from './actions'

const state = {
  all_drivers: [],
  drivers: [],
  driver: {},
  errors: []
}

export default {
  state,
  mutations,
  actions
}